export const THEMES = { CLARO: 'CLARO', OSCURO: 'OSCURO' };
